import React, { Fragment, useState, useEffect, useContext } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Badge,
    ButtonGroup,
    CardHeader,
    Modal,
    ModalBody,
    ModalHeader,
    Form,
    ModalFooter,
} from "reactstrap";
import {
    Nav,
    TabContainer,
    TabContent,
    TabPane,
    Button,
    FormGroup,
    FormLabel,
    NavLink,
    NavItem,
    OverlayTrigger,
    Alert,
    Tooltip,
} from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import ButtonIcon from "../../common/ButtonIcon";
import Loader from "../../common/Loader";
import APICall from "../../../services/apiCall";
import ModalCustom from "../../common/ModalCustom";
import AddEditApplicationForm from "../../ModalPopup/AddEditApplicationForm";
import DeleteApplicationForm from "../../ModalPopup/DeleteApplicationForm";
import CustomerDetailRow from "../../common/CustomerDetailRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFingerprint,
    faIdCard,
    faIdBadge,
    faCalculator,
    faLink,
    faCircleCheck,
    faXmarkCircle,
    faSignature,
    faBan,
    faFileInvoice,
    faPencil,
    faArrowsRotate,
    faMobileButton,
    faPenToSquare,
    faExternalLink,
    faCloudUploadAlt,
} from "@fortawesome/free-solid-svg-icons";
import AppContext from "../../../context/Context";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import SoftBadge from "../../common/SoftBadge";
import AppStatusUpdateModal from "../../ModalPopup/AppStatusUpdateModal";
import MarketplaceStatusUpdateModal from "../../ModalPopup/MarketplaceStatusUpdateModal";
import UpdateAppSLAPlanModal from "../../ModalPopup/UpdateAppSLAPlanModal";
import APIAccessListItem from "./APIAccessListItem";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import Flex from "../../common/Flex";
import SikkaSelect from "../../common/SikkaSelect/SikkaSelect";
import RequestDeleteApplicationForm from "../../ModalPopup/RequestDeleteApplicationForm"; //APIV4-725
import PendingDeleteApplication from "../../ModalPopup/PendingDeleteApplication";
import CopyToClipboard from "../../common/CopyToClipboard";
import PublishApplication from "../../user/PushlishApplication";
//import QuickbookPaymentStatus from "../../ModalPopup/QuickbookPaymentStatus";

const hostName = (url) => {
  if (url.includes("localhost")) {
    return "Q";
  } else if (url.includes("qa")) {
    return "Q";
  } else {
    return "P";
  }
};

const AppsSort = (data) => {
    const sortedData = (Array.isArray(data) ? [...data] : []).sort((a, b) => {
        if (a.app_status == "verified") {
            return -1;
        }
        if (b.app_status == "verified") {
            return 1;
        }
        if (a.app_status == "expired") {
            return -1;
        }
        if (b.app_status == "expired") {
            return 1;
        }
        if (a.app_status == "test") {
            return -1;
        }
        if (b.app_status == "test") {
            return 1;
        }
        return 0;
    });

    return sortedData;
};

const BadgeForApps = ({ status }) => {
    switch (status) {
        case "verified":
            return (
                <>
                    <Badge
                        color={"success"}
                        className="rounded-capsule text-uppercase p-1 mr-2"
                    >
                        {status}
                    </Badge>
                </>
            );

            break;
        case "expired":
            return (
                <>
                    <Badge
                        color={"danger"}
                        className="rounded-capsule text-uppercase p-1 mr-2"
                    >
                        {status}
                    </Badge>
                </>
            );

            break;

        default:
            return (
                <>
                    <Badge
                        color={"secondary"}
                        className="rounded-capsule text-uppercase p-1 mr-2"
                    >
                        {status}
                    </Badge>
                </>
            );
            break;
    }
};

const NavItemComponent = ({ item }) => {
    return (
        <NavItem as="li">
            <NavLink className="mb-0 py-2 cursor-pointer fs--1" eventKey={item}>
                {item}
            </NavLink>
        </NavItem>
    );
};

const badgeMarketPlaceStatus = (status, serviceName) => {
    let marketplaceurl = "";
    let text = "";
    let color = "";

    switch (status?.toLowerCase()) {
        case "in review":
            color = "warning";
            text = "In Review";
            break;
        case "published":
            color = "success";
            text = "Published";
            if (serviceName) {
                marketplaceurl = "https://www.sikkasoft.com/" + serviceName;
                //marketplaceLink="<a href="+marketplaceurl+" target=\"_blank\" className=ml-20>Click here</a>";
            }
            break;
        default:
            color = "danger";
            text = "Not Published";
    }
    return (
        <>
            <Badge color={`soft-${color}`} className="rounded-capsule">
                {text}
            </Badge>{" "}
            {marketplaceurl ? (
                <a
                    href={marketplaceurl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-20"
                >
                    Click here
                </a>
            ) : (
                ""
            )}
        </>
    );
};

const styles = {
    control: (base) => ({
        ...base,
        fontSize: "14px",
    }),
    menu: (base) => ({
        ...base,
        fontSize: "14px",
    }),
};

const navItems = ["GET", "POST", "PUT", "DELETE", "PATCH"];

const ApplicationDetails = ({
    devid,
    selectApplicationDetails,
    isActionAllowed,
    setApplicationList,
    setApplicationID,
    applicationID,
    realoadOpenAPIAccessModal,
    applicationList = [],
    setShowApiAccessButtonClickedCancel,
    selectedApiNames,
    setSelectedApiNames,
    apiLimitNote,
    setApiLimitNote,
    fetchPartnerDetails,
    fetchApplicationDetails,
    setFetchApplicationDetails,
    setFetchApiAccessList, //added to change Api Access Even if AppId is not change
    partnerDetails,
}) => {
    const [loadingApplicationList, setLoadingApplicationList] = useState(true);
    const [loadingApplicationDetails, setLoadingApplicationDetails] = useState(
        true
    );
    const [applicationName, setApplicationName] = useState("");
    const [dropRefresh, setDropRefresh] = useState(false);
    const [applicationSecretKey, setApplicationSecretKey] = useState("");
    const [applicationListData, setApplicationListData] = useState([]);
    const [applicationData, setApplicationData] = useState({});
    // const [applicationID, setApplicationID] = useState();
    const [
        openPopupAddEditApplication,
        setOpenPopupAddEditApplication,
    ] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [isAddMode, setIsAddMode] = useState(true);
    // const [partnerDetails, setPartnerDetails] = useState();
    const [fetchAfterUpdate, setFetchAfterUpdate] = useState(true);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    //APIV4-725 changes start
    const [openRequestDeleteModal, setOpenRequestDeleteModal] = useState(false);
    const [openPendingDeleteModal, setOpenPendingDeleteModal] = useState(false);
    //APIV4-725 changes ends
    const [avatarChanged, setAvatarChanged] = useState(false);
    const [selectedAppId, setSelectedAppId] = useState({ appid: "" });
    const [openAppStatusUpdateModal, setOpenAppStatusUpdateModal] = useState(
        false
    );
    const [openUpdateAppSLAPlanModal, setOpenUpdateAppSLAPlanModal] = useState(
        false
    );
    const [selectedAppStatus, setSelectedAppStatus] = useState(
        applicationData.app_status
    );
    const [openAPIAccessModal, setOpenAPIAccessModal] = useState(false);
    const [domainIdx, setDomainIdx] = useState(0);
    const [apiAccessNameData, setApiAccessNameData] = useState([]);
    const [
        firstStartupApplicationBoolean,
        setFirstStartupApplicationBoolean,
    ] = useState(false);
    const [apiAccessData, setApiAccessData] = useState({});
    const [apiAccessList, setApiAccessList] = useState([]);
    const [disableApiAccessSelection, setDisableApiAccessSelection] = useState(
        false
    );
    const [otherApis, setOtherApis] = useState("");
    const [appIdForAPIAccess, setAppIdForAPIAccess] = useState("");

    // .....................
    const [IsConfirmationModal, setIsConfirmationModal] = useState(false);

    //...........................

    const toggle = () => setIsConfirmationModal(!IsConfirmationModal);
    // ....................

    const [publishStatus, setPublishStatus] = useState("");
    const [publishVisibility, setPublishVisibility] = useState("");
    const [publishServiceID, setPublishServiceID] = useState("");
    const [
        openMarketplaceStatusUpdateModal,
        setOpenMarketplaceStatusUpdateModal,
    ] = useState("");
    const [updatedStatus, setUpdatedStatus] = useState("");
    const appContext = useContext(AppContext);
    const { loginUserDetails, accessToken } = appContext;
    const [openPublishModal, setOpenPublishModal] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [lastSelectedList, setLastSelectedList] = useState([]);
    const [mpApplicationStatus, setMpApplicationStatus] = useState("");
    const addElement = (newElement) => {
        setLastSelectedList((prevList) => {
            const updatedList = [...prevList, newElement];
            if (updatedList.length > 3) {
                updatedList.shift();
            }
            return updatedList;
        });
    };

    useEffect(() => {
        const apiParam = { devid: devid };

        APICall.servertrip(
            "GET",
            "partner_all_apps",
            loginUserDetails,
            apiParam
        ).then(
            (res) => {
                const appItems = AppsSort(res?.data?.items || []);
                setApplicationList(appItems);
                setApplicationListData(appItems);

                let selectedApp = null;

                if (appItems.length > 0) {
                    // 🔍 Try to find last selected app in current list
                    if (lastSelectedList.length > 0) {
                        const lastSelectedApp =
                            lastSelectedList[lastSelectedList.length - 1];
                        selectedApp = appItems.find(
                            (item) => item.app_id === lastSelectedApp?.app_id
                        );
                    }

                    // 🔄 If lastSelectedApp is not found, fallback to first app
                    if (!selectedApp) {
                        selectedApp = appItems[0];
                    }

                    // ✅ Set all state using selectedApp
                    setApplicationName(selectedApp.app_name);
                    setApplicationSecretKey(selectedApp.app_secret_key);
                    selectApplicationDetails(
                        selectedApp,
                        selectedApp.app_name,
                        selectedApp.app_secret_key,
                        selectedApp.app_id
                    );
                    setSelectedAppId({ appid: selectedApp.app_id });
                    setApplicationID(selectedApp.app_id);
                    setPublishStatus(selectedApp.publish_app_status);
                    setPublishVisibility(selectedApp.publish_app_visiblity);
                    setPublishServiceID(selectedApp.publish_app_service_id);
                    addElement(selectedApp);
                } else {
                    // ❌ No apps at all
                    setApplicationName("");
                    setApplicationSecretKey("");
                    selectApplicationDetails({}, "", "", "");
                    setSelectedAppId({ appid: "" });
                    setApplicationID("");
                    setPublishStatus("");
                    setPublishVisibility("");
                    setPublishServiceID("");
                }

                setLoadingApplicationList(false);
                setLoadingApplicationDetails(false);
                setFetchApplicationDetails(true);
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                setLoadingApplicationDetails(false);
                toast.error(resMessage);
            }
        );
    }, [fetchAfterUpdate]);

    useEffect(() => {
        const filteredApplication = applicationList.filter(
            (app) => app.app_id === selectedAppId.appid
        );
        setPublishStatus(filteredApplication[0]?.publish_app_status);
        setPublishVisibility(filteredApplication[0]?.publish_app_visiblity);
        setPublishServiceID(filteredApplication[0]?.publish_app_service_id);
    }, [
        selectedAppId.appid,
        updatedStatus,
        fetchAfterUpdate,
        fetchApplicationDetails,
        dropRefresh,
    ]);

    useEffect(() => {
        if (
            selectedAppId.appid &&
            applicationListData?.length > 0 &&
            fetchApplicationDetails
        ) {
            setLoadingApplicationDetails(true);
            var apiParams = { appid: selectedAppId.appid };
            APICall.servertrip(
                "GET",
                "application_details",
                loginUserDetails,
                apiParams
            ).then(
                (res) => {
                    setApplicationData(res?.data?.items?.[0] || {});
                    setApplicationID(res?.data?.items?.[0]?.app_id || "");
                    setLoadingApplicationDetails(false);
                    setFetchAfterUpdate(false);
                    setFetchApplicationDetails(false);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setLoadingApplicationDetails(false);
                    toast.error(resMessage);
                    setFetchAfterUpdate(false);
                }
            );
        }
    }, [selectedAppId.appid, fetchApplicationDetails]);

    const handleStatusClick = (item) => {
        if (loginUserDetails.is_partner === "0") {
            setOpenMarketplaceStatusUpdateModal(true);
            setUpdatedStatus(item);
        }
    };

    const handlePublishApplicationClick = () => {
        setOpenPublishModal(true);
    };

    const handleAddApplicationBtn = () => {
        // setRecordForEdit(item);
        setIsAddMode(true);
        setOpenPopupAddEditApplication(true);
    };

    const handleEditApplicationBtn = (item) => {
        setRecordForEdit(item);
        setIsAddMode(false);
        setOpenPopupAddEditApplication(true);
        setAvatarChanged(false);
    };

    const handleDeleteApplicationBtn = () => {
        setOpenDeleteModal(true);
        setSelectedAppId({ appid: "" });
    };
    // APIV4-725 update changes here
    const handleRequestDeleteApplicationBtn = () => {
        setOpenRequestDeleteModal(true);
        setSelectedAppId({ appid: "" });
    };
    const handlePendingRequestDeleteApplicationBtn = () => {
        setOpenPendingDeleteModal(true);
        setSelectedAppId({ appid: "" });
    };
    // APIV4-725  ends here

    const addEditApplicationDetails = (values, id) => {
        setFetchAfterUpdate(false);
        if (!id) createApplication(values);
        else updateApplication(id, values);
        // resetForm()
        setRecordForEdit(null);
        // setLoadingApplicationList(true);
        setLoadingApplicationDetails(true);
    };

    function createApplication(values) {
        setFetchAfterUpdate(false);
        let body = {
            plan_id: partnerDetails.plan_id,
            sla_plan_id: partnerDetails.sla_pan_id,
            app_desc: values.app_desc,
            app_name: values.app_name,
            app_site_url: values.app_site_url, //values.app_site_url,
            app_status: "verified", // [always verified for now]
            dev_id: devid, // [Partner dev_id]
            img_byte: values.base64,
            img_name: values.image_name,
            is_add_updated_by_admin:
                loginUserDetails.is_partner === "0" ? "true" : "false", //[if create new application by sikka admin then true else false]
            add_updated_by: loginUserDetails.user_name,
        };

        APICall.servertrip(
            "POST",
            "application",
            loginUserDetails,
            undefined,
            body
        ).then(
            (res) => {
                setFetchAfterUpdate(true);
                setOpenPopupAddEditApplication(false);
                setAppIdForAPIAccess(res.data.message.split(":")[1]);
                if (res.data.message.split(":")[3] === "yes") {
                    //open API Access Selection
                    setFirstStartupApplicationBoolean(true);
                }
                toast.success("Application successfully added");
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
                setOpenPopupAddEditApplication(false);
            }
        );
    }

    function updateApplication(id, values) {
        setFetchAfterUpdate(false);
        let body = {
            app_id: id,
            app_desc: values.app_desc,
            app_name: values.app_name,
            parent_master_customer_id: recordForEdit.parent_master_customer_id,
            app_site_url: values.app_site_url,
            redirect_url: values.redirect_uri,
            app_status: selectedAppStatus
                ? `${selectedAppStatus}`
                : `${recordForEdit.app_status}`,
            dev_id: devid, // [partner dev id]
            app_logo: avatarChanged ? "" : recordForEdit.app_logo,
            img_byte: avatarChanged ? values.base64 : "",
            img_name: avatarChanged ? values.image_name : "",
            add_updated_by: loginUserDetails.user_name, // [loggedin user's user name]
            is_add_updated_by_admin:
                loginUserDetails.is_partner === "0" ? "true" : "false", // [if create new application by sikka admin then true else false]
            before_updated_value: {
                app_name: recordForEdit.app_name,
                app_site_url: recordForEdit.app_site_url,
                redirect_url: recordForEdit.redirect_uri,
                app_status: `${recordForEdit.app_status}`,
                app_desc: recordForEdit.app_desc,
                app_logo: recordForEdit.app_logo,
            },
        };

        setAvatarChanged(false);

        APICall.servertrip(
            "PUT",
            "application",
            loginUserDetails,
            undefined,
            body
        ).then(
            (res) => {
                toast.success(
                    `${
                        values.app_name
                    } Application Details updated successfully`
                );
                //  setFetchAfterUpdate(true);//////cause of the Error
                setDropRefresh(true);
                setFetchApplicationDetails(true);
                setOpenPopupAddEditApplication(false);
                // setpartnerDetailRecord(values)
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
                setOpenPopupAddEditApplication(false);
            }
        );
    }

    const selectApplication = (appData, appName, appKey, appId) => {
        setApplicationName(appName);
        setApplicationSecretKey(appKey);
        setApplicationID(appId);
        selectApplicationDetails(appData, appName, appKey, appId);
    };

    const handleRefreshSecretKey = () => {
        let body = {
            app_id: selectedAppId.appid,
            dev_id: partnerDetails?.devid, //partner dev id
            dev_name: partnerDetails?.dev_name, //parner dev name logged in users devName
            add_updated_by: loginUserDetails.user_name, // logged in users email address
            is_add_updated_by_admin:
                loginUserDetails.is_partner === "0" ? "true" : "false", // value must be true or false. if add/updated by sikka admin then true else false.
        };
        APICall.servertrip(
            "PUT",
            "secret_key",
            loginUserDetails,
            undefined,
            body
        )
            .then((res) => {
                toast.success(
                    "Your Secret key has been reset successfully reset."
                );
                setIsConfirmationModal(false);
                setFetchApplicationDetails(true);
            })
            .catch((error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
                setIsConfirmationModal(false);
            });
    };

    useEffect(() => {
        if (firstStartupApplicationBoolean) {
            let params = {
                is_devloper: true,
                devid: loginUserDetails.dev_id,
            };
            // setApiAccessList([]);
            APICall.servertrip(
                "GET",
                "api_name_for_access",
                loginUserDetails,
                params
            ).then(
                (res) => {
                    let apiAccessNameData = {
                        get: [],
                        post: [],
                        put: [],
                        delete: [],
                        patch: [],
                    };
                    let items = res?.data?.items.map((data) => {
                        if (data.method === "GET") {
                            apiAccessNameData["get"].push(data.api_name);
                        } else if (data.method === "POST") {
                            apiAccessNameData["post"].push(data.api_name);
                        } else if (data.method === "PUT") {
                            apiAccessNameData["put"].push(data.api_name);
                        } else if (data.method === "PATCH") {
                            apiAccessNameData["patch"].push(data.api_name);
                        } else if (data.method === "DELETE") {
                            apiAccessNameData["delete"].push(data.api_name);
                        }
                        return "";
                    });

                    if (loginUserDetails.is_partner == "1") {
                        setApiAccessNameData(apiAccessNameData);
                    } else {
                        setApiAccessNameData(res?.data?.items[0]);
                    }
                    setOpenAPIAccessModal(true);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    // setLoading(false);
                    toast.error(resMessage);
                }
            );
        }
    }, [firstStartupApplicationBoolean, realoadOpenAPIAccessModal]);

    const handleAddingOfAPIAccess = (values) => {
        // debugger;
        let selectApis =
            selectedApiNames.length > 0
                ? values.otherAPIs
                    ? selectedApiNames
                          .join(",")
                          .concat(",")
                          .concat(
                              values.otherAPIs
                                  .split(",")
                                  .filter((data) => data)
                                  .join(",")
                          )
                    : selectedApiNames.join(",")
                : values.otherAPIs
                      .split(",")
                      .filter((data) => data)
                      .join(",");
        // POST Req
        let body = {
            app_id: appIdForAPIAccess, // application ID
            api_names: selectApis, //Selected API by seperated comma
            api_limit_note: values.apiLimitNote, //|| applicationDetails.app_name, // you can add For <application name>
            domain_name: domains[domainIdx], //value must be all for now.
            add_updated_by: loginUserDetails.user_name, // Logged in username
            user_dev_id: loginUserDetails.dev_id,
        };
        APICall.servertrip(
            "POST",
            "api_access",
            loginUserDetails,
            undefined,
            body
        ).then(
            (res) => {
                setOpenAPIAccessModal(false);
                setOtherApis("");
                toast.success("API Selection successfully completed");
                setSelectedApiNames([]);
                setApiLimitNote("");
                setFetchApiAccessList(true); //setFetchApiAccessList is added here get ApiAccessList
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
            }
        );
    };

    const selectStyles = {
        control: (base) => ({
            ...base,
            fontSize: "12px",
            height: 33,
            minHeight: 33,
        }),
        menu: (base) => ({
            ...base,
            fontSize: "14px",
        }),
    };

    const domains = ["all"];

    const handleChange = (apiName, selected) => {
        if (selected && selectedApiNames.length < 14) {
            const updatedTodos = selectedApiNames.concat(apiName);
            setSelectedApiNames(updatedTodos);
        } else if (selected) {
            const updatedTodos = selectedApiNames.concat(apiName);
            setSelectedApiNames(updatedTodos);
            setDisableApiAccessSelection(true);
            toast.warning(
                "Max limit of API Access reached for the selected plan"
            );
        } else {
            const updatedTodos = selectedApiNames.filter(
                (name) => name !== apiName
            );
            setSelectedApiNames(updatedTodos);
            setDisableApiAccessSelection(false);
        }
    };

    const [applicationDeleteStatus, setApplicationDeleteStatus] = useState({});

    const [
        isApplicationDeleteStatusLoading,
        setisApplicationDeleteStatusLoading,
    ] = useState(true);

    const [
        deleteRequestFetchAfterUpdate,
        setDeleteRequestFetchAfterUpdate,
    ] = useState(true);

    const FetchApplicationDeleteStatus = () => {
        setisApplicationDeleteStatusLoading(true);
        let apiParam = {
            app_id: selectedAppId.appid,
            devid: loginUserDetails.dev_id,
        };
        APICall.servertrip(
            "GET",
            "get_application_delete_status",
            loginUserDetails,
            apiParam
        ).then(
            (res) => {
                setisApplicationDeleteStatusLoading(false);
                setApplicationDeleteStatus(res.data.items);
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                setisApplicationDeleteStatusLoading(false);
                toast.error(resMessage);
            }
        );
    };

    useEffect(() => {
        if (selectedAppId.appid && deleteRequestFetchAfterUpdate) {
            FetchApplicationDeleteStatus();
        }
    }, [selectedAppId.appid, deleteRequestFetchAfterUpdate]);

    // for api call should be here

    const [
        isUpdateMarketplaceBtnClicked,
        setIsUpdateMarketplaceBtnClicked,
    ] = useState(false);

    const updateMarketplaceStatus = (status) => {
        let body = {
            app_id: applicationData?.app_id,
            partner_id: applicationData?.marketplace_partnerid,
            service_id: applicationData?.marketplace_serviceid,
            service_status: status,
            approved_by: loginUserDetails?.user_name,
            sikka_marketplace_service:
                applicationData?.sikka_marketplace_service,
        };
        APICall.servertrip(
            "PUT",
            "publish_application_update_status",
            loginUserDetails,
            undefined,
            body
        ).then(
            (res) => {
                toast.success(res.data.message);
                setFetchAfterUpdate(true);
                setFetchApplicationDetails(true);
                setIsUpdateMarketplaceBtnClicked(false);
            },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
                setIsUpdateMarketplaceBtnClicked(false);
            }
        );
    };

    // const [
    //     openQuick_Payment_StatusModal,
    //     setOpenQuick_Payment_StatusModal,
    // ] = useState(false);
    // useEffect(() => {
    //      if (window.location.href.toLowerCase().includes("qaapiv4") || window.location.href.toLowerCase().includes("localhost")) {    
    //     if (loginUserDetails.is_partner === "1") {
    //         const params = {
    //             dev_id: devid,
    //             user_dev_id: loginUserDetails.dev_id,
    //         };
    //         APICall.servertrip(
    //             "GET",
    //             "quickbook_payment_status_popup",
    //             loginUserDetails,
    //             params
    //         ).then(
    //             (res) => {
    //                 const response = res?.data;
    //                 const hasShownPopup = localStorage.getItem(
    //                     "hasShownPaymentPopup"
    //                 );
    //                 if (response?.is_payment_paid === false && response?.no_data === false) {
    //                     if (!hasShownPopup) {
    //                         setOpenQuick_Payment_StatusModal(true);
    //                         localStorage.setItem(
    //                             "hasShownPaymentPopup",
    //                             "true"
    //                         );
    //                     } else {
    //                         console.log("Payment popup already shown");
    //                     }
    //                 } else {
    //                     setOpenQuick_Payment_StatusModal(false);
    //                      console.log("close quick payment status modal");
    //                 }
    //             },
    //             (error) => {
    //                 console.log(error);
    //             }
    //         );
    //     }
    // }
    // else{
    //     setOpenQuick_Payment_StatusModal(false);
    // }
    // }, [loginUserDetails]);

    return (
        <>
            <Card className="mb-3">
                <Fragment>
                    <SikkaCardHeader title="Application(s)" />
                </Fragment>
                <CardBody>
                    {loadingApplicationList ? (
                        <Loader />
                    ) : (
                        <SikkaSelect
                            // styles={styles}
                            classNamePrefix="react-select"
                            options={applicationListData.map(
                                (practice, index) => {
                                    return {
                                        value: `${practice?.app_name}`,
                                        label: (
                                            <>
                                                <BadgeForApps
                                                    status={
                                                        practice?.app_status
                                                    }
                                                />{" "}
                                                <span className="text-capitalize">
                                                    {practice?.app_name}
                                                </span>
                                            </>
                                        ),
                                    };
                                }
                            )}
                            defaultValue={applicationName}
                            isSearchable={true}
                            noOptionsMessage={() => "No Applications"}
                            value={{
                                value: applicationName,
                                label: applicationName,
                            }}
                            onChange={(selectedOption) => {
                                let appData = applicationListData.find(
                                    (e) => e.app_name === selectedOption.value
                                );
                                addElement(appData);
                                selectApplication(
                                    appData,
                                    selectedOption.value,
                                    appData.app_secret_key,
                                    appData.app_id
                                );
                                selectApplicationDetails(
                                    appData,
                                    selectedOption.value,
                                    appData.app_secret_key,
                                    appData.app_id
                                );
                                setSelectedAppId({ appid: appData.app_id });
                                setFetchApplicationDetails(true);
                            }}
                        />
                    )}
                </CardBody>
            </Card>

            {loginUserDetails.is_partner === "1" ||
            (loginUserDetails.is_partner === "0" &&
                isActionAllowed("liApplicationDetailsComponent")) ? (
                <Card className="mb-3">
                    <Fragment>
                        <SikkaCardHeader title="Application Details">
                            <div className="d-flex flex-wrap flex-sm-nowrap mt-2">
                                {(loginUserDetails.is_partner === "1" &&
                                    (loginUserDetails.user_type.toLowerCase() ===
                                        "super admin" ||
                                        loginUserDetails.user_type.toLowerCase() ===
                                            "admin")) ||
                                (loginUserDetails.is_partner === "0" &&
                                    isActionAllowed(
                                        "liAddApplicationButton"
                                    )) ? (
                                    <ButtonIcon
                                        color="outline-primary"
                                        size="sm"
                                        icon="plus"
                                        className="mx-1 mt-2 mt-lg-0"
                                        iconClassName="fs--2"
                                        onClick={() => {
                                            if (
                                                applicationListData.length < 5
                                            ) {
                                                handleAddApplicationBtn();
                                            } else {
                                                toast.warning(
                                                    "Not allowed to create more than 5 application. If you want to create application please contact sikka API team."
                                                );
                                            }
                                        }}
                                    >
                                        Add App
                                    </ButtonIcon>
                                ) : (
                                    <div />
                                )}
                                {loginUserDetails.is_partner === "0" &&
                                applicationListData.length > 0 ? (
                                    <ButtonIcon
                                        color="outline-primary"
                                        size="sm"
                                        icon={faCloudUploadAlt}
                                        className="mx-1 mt-2 mt-lg-0"
                                        iconClassName="fs--2"
                                        onClick={handlePublishApplicationClick}
                                    >
                                        Publish Application
                                    </ButtonIcon>
                                ) : (
                                    <div />
                                )}
                                {applicationListData.length > 0 ? (
                                    (loginUserDetails.is_partner === "1" &&
                                        (loginUserDetails.user_type.toLowerCase() ===
                                            "super admin" ||
                                            loginUserDetails.user_type.toLowerCase() ===
                                                "admin")) ||
                                    (loginUserDetails.is_partner === "0" &&
                                        isActionAllowed(
                                            "liUpdateApplicationButton"
                                        )) ? (
                                        <ButtonIcon
                                            color="outline-primary"
                                            size="sm"
                                            icon={faPencil}
                                            className="mx-1 mt-2 mt-lg-0"
                                            iconClassName="fs--2"
                                            onClick={() => {
                                                handleEditApplicationBtn(
                                                    applicationData
                                                );
                                            }}
                                        >
                                            Update App
                                        </ButtonIcon>
                                    ) : (
                                        <div />
                                    )
                                ) : (
                                    <div />
                                )}
                                {/*  APIV4-725  before update ==> this so changes could be reverted back to this*/}
                                {/* {applicationListData.length > 0 ? (
                  (loginUserDetails.is_partner === "1" &&
                    (loginUserDetails.user_type.toLowerCase() === "super admin" ||
                      loginUserDetails.user_type.toLowerCase() === "admin")) ||
                  (loginUserDetails.is_partner === "0" && isActionAllowed("liDeleteApplicationButton")) ? ( //
                    <ButtonIcon
                      color="outline-danger"
                      size="sm"
                      icon="trash"
                      iconClassName="fs--2"
                      className="mx-1 mt-2 mt-lg-0"
                      onClick={() => {
                        handleDeleteApplicationBtn(applicationData);
                      }}
                    >
                      Delete App 
                    </ButtonIcon>
                  ) : (
                    <div />
                  )
                ) : (
                  <div />
                )}
              </div> */}
                                {/*  APIV4-725  before update */}
                                {/* APIV4-725  changes start here */}
                                {/* for api admin side */}
                                {applicationList?.length > 0 &&
                                (applicationDeleteStatus?.request_status ==
                                    "pending" &&
                                    loginUserDetails.is_partner == "0" &&
                                    isActionAllowed(
                                        "liPendingDeleteApplicationButton"
                                    )) ? (
                                    <>
                                        <ButtonIcon
                                            color="outline-info"
                                            size="sm"
                                            icon="trash"
                                            iconClassName="fs--2"
                                            className="mx-1 mt-2 mt-lg-0"
                                            onClick={() => {
                                                setOpenPendingDeleteModal(true);
                                            }}
                                        >
                                            Delete Request Pending
                                        </ButtonIcon>
                                    </>
                                ) : (
                                    <></>
                                )}
                                {/* for api user side */}
                                {applicationList?.length > 0 &&
                                loginUserDetails.is_partner == "1" &&
                                (loginUserDetails.user_type?.toLowerCase() ===
                                    "super admin" ||
                                    loginUserDetails.user_type?.toLowerCase() ===
                                        "admin") ? (
                                    <>
                                        {applicationDeleteStatus?.request_status !==
                                        "pending" ? (
                                            <ButtonIcon
                                                color="outline-danger"
                                                size="sm"
                                                icon="trash"
                                                iconClassName="fs--2"
                                                className="mx-1 mt-2 mt-lg-0"
                                                onClick={() => {
                                                    handleRequestDeleteApplicationBtn(
                                                        applicationData
                                                    );
                                                }}
                                            >
                                                Request Delete App
                                            </ButtonIcon>
                                        ) : (
                                            <ButtonIcon
                                                color="outline-info"
                                                size="sm"
                                                icon="trash"
                                                iconClassName="fs--2"
                                                className="mx-1 mt-2 mt-lg-0"
                                                onClick={() => {
                                                    setOpenPendingDeleteModal(
                                                        true
                                                    );
                                                }}
                                            >
                                                Delete Request Pending
                                            </ButtonIcon>
                                        )}
                                    </>
                                ) : (
                                    <></>
                                )}

                                {applicationListData.length > 0 ? (
                                    loginUserDetails.is_partner === "0" &&
                                    isActionAllowed(
                                        "liDeleteApplicationButton"
                                    ) ? ( //
                                        <ButtonIcon
                                            color="outline-danger"
                                            size="sm"
                                            icon="trash"
                                            iconClassName="fs--2"
                                            className="mx-1 mt-2 mt-lg-0"
                                            onClick={() => {
                                                handleDeleteApplicationBtn(
                                                    applicationData
                                                );
                                            }}
                                        >
                                            Delete App
                                        </ButtonIcon>
                                    ) : (
                                        <div />
                                    )
                                ) : (
                                    <div />
                                )}
                            </div>
                            {/*  APIV4-725  Ends here */}
                        </SikkaCardHeader>

                        <CardBody className="border-top">
                            {applicationListData.length > 0 ? (
                                loadingApplicationDetails &&
                                applicationData &&
                                isApplicationDeleteStatusLoading ? (
                                    <Loader />
                                ) : (
                                    <>
                                        <Row>
                                            <Col>
                                                <div className="d-flex flex-column align-items-center">
                                                    <img
                                                        className="img-thumbnail mb-1"
                                                        src={
                                                            applicationData.app_logo
                                                                ? applicationData.app_logo
                                                                : "https://ui-avatars.com/api/?name=" +
                                                                  applicationData.app_name +
                                                                  "&background=random"
                                                        }
                                                        alt=""
                                                        width={100}
                                                        height={50}
                                                        style={{
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                    <p
                                                        className="fs--1 mt-1"
                                                        style={{
                                                            color: "#9da9bb",
                                                        }}
                                                    >
                                                        {
                                                            applicationData.app_reg_date
                                                        }
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="col-xxl-6 col-md-6 col-lg-6">
                                                <CustomerDetailRow
                                                    title="Application ID"
                                                    icon={faIdBadge}
                                                >
                                                    {loginUserDetails.is_partner ===
                                                        "1" ||
                                                    (loginUserDetails.is_partner ===
                                                        "0" &&
                                                        isActionAllowed(
                                                            "liApplicationIDLabel"
                                                        ))
                                                        ? applicationData.app_id
                                                        : applicationData.app_id?.substring(
                                                              0,
                                                              6
                                                          ) +
                                                          "*".repeat(
                                                              applicationData
                                                                  .app_id
                                                                  ?.length
                                                          )}
                                                </CustomerDetailRow>
                                                <CustomerDetailRow
                                                    title="Application Secret Key"
                                                    icon={faFingerprint}
                                                >
                                                    <div className="d-flex">
                                                        {loginUserDetails.is_partner ===
                                                            "1" ||
                                                        (loginUserDetails.is_partner ===
                                                            "0" &&
                                                            isActionAllowed(
                                                                "liApplicationKeyTable"
                                                            ))
                                                            ? applicationData.app_secret_key
                                                            : applicationData.app_secret_key?.substring(
                                                                  0,
                                                                  6
                                                              ) +
                                                              "*".repeat(
                                                                  applicationData
                                                                      .app_secret_key
                                                                      ?.length
                                                              )}
                                                        {(loginUserDetails.is_partner ===
                                                            "1" &&
                                                            (loginUserDetails.user_type.toLowerCase() ===
                                                                "super admin" ||
                                                                loginUserDetails.user_type.toLowerCase() ===
                                                                    "admin")) ||
                                                        (loginUserDetails.is_partner ===
                                                            "0" &&
                                                            isActionAllowed(
                                                                "liApplicationSecretKeyRefreshButton"
                                                            )) ? (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                delay={{
                                                                    show: 200,
                                                                    hide: 200,
                                                                }}
                                                                overlay={
                                                                    <Tooltip id="refreshSecretKey">
                                                                        Reset
                                                                        Secret
                                                                        Key
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div id="refreshSecretKey">
                                                                    <FontAwesomeIcon
                                                                        className="ml-2 cursor-pointer"
                                                                        icon={
                                                                            faArrowsRotate
                                                                        }
                                                                        onClick={() => {
                                                                            setIsConfirmationModal(
                                                                                true
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            </OverlayTrigger>
                                                        ) : (
                                                            <div />
                                                        )}
                                                    </div>
                                                </CustomerDetailRow>
                                                <CustomerDetailRow
                                                    title="Customer Count"
                                                    icon={faCalculator}
                                                >
                                                    {
                                                        applicationData.no_of_installations
                                                    }
                                                </CustomerDetailRow>
                                                <CustomerDetailRow
                                                    title="Parent Master ID"
                                                    icon={faIdBadge}
                                                >
                                                    {
                                                        applicationData.parent_master_customer_id
                                                    }
                                                </CustomerDetailRow>
                                                <CustomerDetailRow
                                                    title="Application Status"
                                                    isLastItem
                                                    icon={faMobileButton}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        {applicationData.app_status ===
                                                        "verified" ? (
                                                            <SoftBadge
                                                                pill
                                                                bg="success"
                                                                className="me-2"
                                                            >
                                                                {applicationData.app_status
                                                                    ?.charAt(0)
                                                                    .toUpperCase() +
                                                                    applicationData.app_status?.slice(
                                                                        1
                                                                    )}
                                                            </SoftBadge>
                                                        ) : (
                                                            <SoftBadge
                                                                pill
                                                                bg="danger"
                                                                className="me-2"
                                                            >
                                                                {applicationData.app_status
                                                                    ?.charAt(0)
                                                                    .toUpperCase() +
                                                                    applicationData.app_status?.slice(
                                                                        1
                                                                    )}
                                                            </SoftBadge>
                                                        )}
                                                        {loginUserDetails.is_partner ===
                                                            "0" &&
                                                        isActionAllowed(
                                                            "liApplicationStatusUpdateButton"
                                                        ) ? (
                                                            <Col>
                                                                <ButtonGroup>
                                                                    <Button
                                                                        id="btnTeamMemberAccessTypeShow"
                                                                        className={
                                                                            applicationData?.app_status?.toLowerCase() ===
                                                                            "verified"
                                                                                ? "btn btn-xs btn-success"
                                                                                : "btn btn-xs btn-secondary"
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                applicationData?.app_status?.toLowerCase() !==
                                                                                "verified"
                                                                            ) {
                                                                                setOpenAppStatusUpdateModal(
                                                                                    true
                                                                                );
                                                                                setSelectedAppStatus(
                                                                                    "verified"
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        Verified
                                                                    </Button>
                                                                    <Button
                                                                        id="btnTeamMemberAccessTypeShow"
                                                                        className={
                                                                            applicationData?.app_status?.toLowerCase() ===
                                                                            "expired"
                                                                                ? "btn btn-xs btn-success"
                                                                                : "btn btn-xs btn-secondary"
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                applicationData?.app_status?.toLowerCase() !==
                                                                                "expired"
                                                                            ) {
                                                                                setOpenAppStatusUpdateModal(
                                                                                    true
                                                                                );
                                                                                setSelectedAppStatus(
                                                                                    "expired"
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        Expired
                                                                    </Button>
                                                                    <Button
                                                                        id="btnOffAc"
                                                                        className={
                                                                            applicationData?.app_status?.toLowerCase() ===
                                                                            "test"
                                                                                ? "btn btn-xs btn-success"
                                                                                : "btn btn-xs btn-secondary"
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                applicationData?.app_status?.toLowerCase() !==
                                                                                "test"
                                                                            ) {
                                                                                setOpenAppStatusUpdateModal(
                                                                                    true
                                                                                );
                                                                                setSelectedAppStatus(
                                                                                    "test"
                                                                                );
                                                                            }
                                                                        }}
                                                                    >
                                                                        Test
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </Col>
                                                        ) : (
                                                            <div />
                                                        )}
                                                    </div>
                                                </CustomerDetailRow>
                                                
                                            </Col>
                                            <Col className="col-xxl-6 col-lg-6 col-md-6 col-12 mt-sm-0 mt-md-0 mt-lg-0">
                                                <CustomerDetailRow
                                                    title="Redirect URI"
                                                    icon={faLink}
                                                >
                                                    {applicationData.redirect_uri ? (
                                                        <a
                                                            href={
                                                                applicationData.redirect_uri
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {
                                                                applicationData.redirect_uri
                                                            }
                                                        </a>
                                                    ) : (
                                                        <p className="font-italic text-400 mb-0">
                                                            Redirect URI not set
                                                        </p>
                                                    )}
                                                </CustomerDetailRow>
                                                <CustomerDetailRow
                                                    title="Marketplace Status"
                                                    isLastItem
                                                    icon={
                                                        applicationData.marketplace_status ===
                                                        "Published"
                                                            ? faCircleCheck
                                                            : faXmarkCircle
                                                    }
                                                >
                                                    <div className="d-flex align-items-center">
                                                        {badgeMarketPlaceStatus(
                                                            applicationData.marketplace_status,
                                                            applicationData.sikka_marketplace_service
                                                        )}{" "}
                                                        <Col>
                                                            {applicationData?.app_status ===
                                                                "verified" &&
                                                                loginUserDetails.is_partner ===
                                                                    "0" && (
                                                                    <>
                                                                        <ButtonGroup>
                                                                            {publishStatus?.toLowerCase() ==
                                                                                "published" && (
                                                                                <>
                                                                                    <Button
                                                                                        id="btnTeamMemberAccessTypeShow"
                                                                                        className={
                                                                                            publishVisibility?.toLowerCase() ===
                                                                                            "public"
                                                                                                ? "btn btn-xs btn-success"
                                                                                                : "btn btn-xs btn-secondary"
                                                                                        }
                                                                                        onClick={() => {
                                                                                            if (
                                                                                                publishVisibility?.toLowerCase() !==
                                                                                                "public"
                                                                                            ) {
                                                                                                handleStatusClick(
                                                                                                    "Public"
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        Public
                                                                                    </Button>
                                                                                    <Button
                                                                                        id="btnTeamMemberAccessTypeShow"
                                                                                        className={
                                                                                            publishVisibility?.toLowerCase() ===
                                                                                            "private"
                                                                                                ? "btn btn-xs btn-success"
                                                                                                : "btn btn-xs btn-secondary"
                                                                                        }
                                                                                        onClick={() => {
                                                                                            if (
                                                                                                publishVisibility?.toLowerCase() !==
                                                                                                "private"
                                                                                            ) {
                                                                                                handleStatusClick(
                                                                                                    "Private"
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        Private
                                                                                    </Button>
                                                                                </>
                                                                            )}

                                                                            {applicationData?.marketplace_status !==
                                                                                "" && (
                                                                                <>
                                                                                    {applicationData?.marketplace_status ===
                                                                                    "Published" ? (
                                                                                        <>
                                                                                            <Button
                                                                                                id="btnTeamMemberAccessTypeShow"
                                                                                                className={
                                                                                                    "btn btn-xs btn-secondary"
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    if (
                                                                                                        !(
                                                                                                            applicationData?.marketplace_status ===
                                                                                                                "In Review" ||
                                                                                                            applicationData?.marketplace_status ===
                                                                                                                "Unpublished"
                                                                                                        )
                                                                                                    ) {
                                                                                                        setMpApplicationStatus(
                                                                                                            "inactive"
                                                                                                        );
                                                                                                        setOpenMarketplaceStatusUpdateModal(
                                                                                                            true
                                                                                                        );
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                Deactivate
                                                                                            </Button>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Button
                                                                                                id="btnTeamMemberAccessTypeShow"
                                                                                                className={
                                                                                                    "btn btn-xs btn-success"
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    if (
                                                                                                        !(
                                                                                                            applicationData?.marketplace_status ===
                                                                                                            "Published"
                                                                                                        )
                                                                                                    ) {
                                                                                                        setMpApplicationStatus(
                                                                                                            "active"
                                                                                                        );
                                                                                                        setOpenMarketplaceStatusUpdateModal(
                                                                                                            true
                                                                                                        );
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                Activate
                                                                                            </Button>
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </ButtonGroup>
                                                                    </>
                                                                )}
                                                        </Col>
                                                    </div>
                                                </CustomerDetailRow>
                                                
                                                {["0", "1"].includes(loginUserDetails?.is_partner) && (
                                                                                <CustomerDetailRow title="Billing" isLastItem icon={faFileInvoice}>
                            {applicationData.is_billing_configured === "yes" ? "Configured" : "Not Configured"}
                            {loginUserDetails.is_partner === "0" && applicationData.billing_status && (
                                <> - {applicationData.billing_status}</>
                            )}
                            </CustomerDetailRow>
                                                )}
                                                
                                                {applicationData?.spu_installer_link?.trim() ? (
                                                <CustomerDetailRow
                                                    title="Download SPU"
                                                    isLastItem
                                                    icon={
                                                        applicationData.marketplace_status === "Published"
                                                            ? faCircleCheck
                                                            : faXmarkCircle
                                                    }
                                                >
                                                    <a
                                                        href={applicationData.spu_installer_link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Link to download
                                                    </a>
                                                </CustomerDetailRow>
                                            ) : (
                                                <CustomerDetailRow
                                                    title="Download SPU"
                                                    isLastItem
                                                    icon={
                                                        applicationData.marketplace_status === "Published"
                                                            ? faCircleCheck
                                                            : faXmarkCircle
                                                    }
                                                >
                                                    <a
                                                        href="https://sscsetups.s3.amazonaws.com/SikkaUtilityInstaller.exe"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Link to download
                                                    </a>
                                                </CustomerDetailRow>
                                            )}
                                                {/* <CustomerDetailRow
                                                    title="SLA Plan"
                                                    isLastItem
                                                    icon={faFileInvoice}
                                                >
                                                    <div className="d-flex align-items-baseline">
                                                        {applicationData.sla_plan_name ? (
                                                            applicationData.sla_plan_name
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                            applicationData.sla_plan_name.slice(
                                                                1
                                                            )
                                                        ) : (
                                                            <p className="font-italic text-400 mb-0">
                                                                SLA Plan Not
                                                                Assign
                                                            </p>
                                                        )}
                                                        {loginUserDetails.is_partner ===
                                                            "0" &&
                                                        isActionAllowed(
                                                            "liApplicationSLAPlanUpdateButton"
                                                        ) ? (
                                                            <ButtonIcon
                                                                icon={
                                                                    faPenToSquare
                                                                }
                                                                transform="shrink-3 down-2"
                                                                color="outline-primary"
                                                                size="sm"
                                                                className="mt-lg-0 mb-2 fs--1 ml-3"
                                                                onClick={() =>
                                                                    setOpenUpdateAppSLAPlanModal(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                SLA Plan
                                                            </ButtonIcon>
                                                        ) : (
                                                            <div />
                                                        )}
                                                    </div>
                                                </CustomerDetailRow> */}
                                                 {applicationData?.appType !== "sikka_api_plus_plus" && (
                                                    <CustomerDetailRow
                                                        title="API Licence"
                                                        icon={faIdCard}
                                                    >
                                                        {applicationData?.licenseType?.trim() || "--"}
                                                    </CustomerDetailRow>
                                                )}
                                                     {applicationList.find(
                                                    (tempAppDetails) =>
                                                        tempAppDetails.app_id ==
                                                        applicationData.app_id
                                                )?.project_id != "" ? (
                                                    <CustomerDetailRow
                                                        title="API++ URI"
                                                        isLastItem
                                                        icon={faExternalLink}
                                                    >
                                                        <CopyToClipboard
                                                            type="link"
                                                            textToCopy={`https://agent.sikka.ai/${
                                                                applicationList.find(
                                                                    (
                                                                        tempAppDetails
                                                                    ) =>
                                                                        tempAppDetails?.app_id ==
                                                                        applicationData?.app_id
                                                                )?.project_id
                                                            }`}
                                                        />
                                                    </CustomerDetailRow>
                                                ) : (
                                                    <></>
                                                )}
                                            </Col>
                                        </Row>
                                    </>
                                )
                            ) : (
                                <Alert
                                    className="alert alert-info mb-0"
                                    role="alert"
                                >
                                    No applications for this partner.
                                </Alert>
                            )}
                        </CardBody>
                    </Fragment>
                </Card>
            ) : (
                <div />
            )}
            <ModalCustom
                title={isAddMode ? "Add Application" : "Edit Application"}
                openPopup={openPopupAddEditApplication}
                setOpenPopup={setOpenPopupAddEditApplication}
                size="lg"
            >
                <AddEditApplicationForm
                    isAddMode={isAddMode}
                    applicationData={applicationData}
                    recordForEdit={recordForEdit}
                    addEditApplicationDetails={addEditApplicationDetails}
                    setOpenPopupForAddEditApplication={(temp) =>
                        setOpenPopupAddEditApplication(temp)
                    }
                    avatarChanged={avatarChanged}
                    setAvatarChanged={setAvatarChanged}
                    applicationListData={applicationListData}
                    setFetchAfterUpdate={setFetchAfterUpdate}
                    partnerDetails={partnerDetails}
                />
            </ModalCustom>
            <ModalCustom
                title="Delete Application"
                openPopup={openDeleteModal}
                setOpenPopup={setOpenDeleteModal}
                size="md"
            >
                <DeleteApplicationForm
                    applicationData={applicationData}
                    loginUserDetails={loginUserDetails}
                    setOpenDeleteModal={setOpenDeleteModal}
                    applicationList={applicationList}
                    setFetchAfterUpdate={setFetchAfterUpdate}
                    setSelectedApiNames={setSelectedApiNames}
                    setApiLimitNote={setApiLimitNote}
                    setFirstStartupApplicationBoolean={
                        setFirstStartupApplicationBoolean
                    }
                />
            </ModalCustom>
            {/* APIV4-725  change start here */}
            <ModalCustom
                title="Delete Application Request"
                openPopup={openRequestDeleteModal}
                setOpenPopup={setOpenRequestDeleteModal}
                size="md"
            >
                <RequestDeleteApplicationForm //
                    applicationData={applicationData}
                    loginUserDetails={loginUserDetails}
                    setOpenDeleteModal={setOpenRequestDeleteModal}
                    applicationList={applicationList}
                    setFetchAfterUpdate={setDeleteRequestFetchAfterUpdate}
                    setSelectedApiNames={setSelectedApiNames}
                    setApiLimitNote={setApiLimitNote}
                    setFirstStartupApplicationBoolean={
                        setFirstStartupApplicationBoolean
                    }
                    fetchAfterUpdate={deleteRequestFetchAfterUpdate}
                    setSelectedAppId={setSelectedAppId}
                />
            </ModalCustom>

            <ModalCustom
                title="Pending Application Request"
                openPopup={openPendingDeleteModal}
                setOpenPopup={setOpenPendingDeleteModal}
                size="md"
            >
                <PendingDeleteApplication //
                    applicationData={applicationData}
                    loginUserDetails={loginUserDetails}
                    setOpenDeleteModal={setOpenPendingDeleteModal}
                    applicationList={applicationList}
                    setFetchAfterUpdate={setDeleteRequestFetchAfterUpdate}
                    setSelectedApiNames={setSelectedApiNames}
                    setApiLimitNote={setApiLimitNote}
                    setFirstStartupApplicationBoolean={
                        setFirstStartupApplicationBoolean
                    }
                    applicationDeleteStatus={applicationDeleteStatus}
                    setRefreshAfterDelete={setFetchAfterUpdate}
                />
            </ModalCustom>

            {/*  APIV4-725 ends here */}
            <ModalCustom
                title="Add comment"
                openPopup={openAppStatusUpdateModal}
                setOpenPopup={setOpenAppStatusUpdateModal}
                size="lg"
            >
                <AppStatusUpdateModal
                    applicationData={applicationData}
                    setOpenAppStatusUpdateModal={setOpenAppStatusUpdateModal}
                    // setFetchAfterUpdate={setFetchAfterUpdate}
                    setFetchApplicationDetails={setFetchApplicationDetails}
                    selectedAppStatus={selectedAppStatus}
                    partnerDetails={partnerDetails}
                    setFetchAfterUpdate={setFetchAfterUpdate}
                    partnerDevId={devid}
                />
            </ModalCustom>

            <ModalCustom
                title={`Update Marketplace Status${
                    updatedStatus ? ` - ${updatedStatus}` : ""
                }`}
                openPopup={openMarketplaceStatusUpdateModal}
                setOpenPopup={setOpenMarketplaceStatusUpdateModal}
                size="lg"
            >
                <MarketplaceStatusUpdateModal
                    publishServiceID={publishServiceID}
                    setOpenMarketplaceStatusUpdateModal={
                        setOpenMarketplaceStatusUpdateModal
                    }
                    updatedStatus={updatedStatus}
                    setFetchAfterUpdate={setFetchAfterUpdate}
                    mpApplicationStatus={mpApplicationStatus}
                    setMpApplicationStatus={setMpApplicationStatus}
                    setUpdatedStatus={setUpdatedStatus}
                />
            </ModalCustom>

            <ModalCustom
                title="Edit SLA Plan"
                openPopup={openUpdateAppSLAPlanModal}
                setOpenPopup={setOpenUpdateAppSLAPlanModal}
                size="xl"
            >
                <UpdateAppSLAPlanModal
                    applicationData={applicationData}
                    setOpenUpdateAppSLAPlanModal={setOpenUpdateAppSLAPlanModal}
                    // setFetchAfterUpdate={setFetchAfterUpdate}
                    setFetchApplicationDetails={setFetchApplicationDetails}
                    partnerDetails={partnerDetails}
                />
            </ModalCustom>

            <ModalCustom
                title="Publish Application"
                openPopup={openPublishModal}
                setOpenPopup={setOpenPublishModal}
                size="xl"
            >
                <AppContext.Provider
                    value={{
                        ...appContext,
                        loginUserDetails: {
                            ...loginUserDetails,
                            parent_dev_id: devid,
                        },
                    }}
                >
                    <PublishApplication skipBillingCheck={true} />
                </AppContext.Provider>
            </ModalCustom>

            {/* <ModalCustom
                title="Payment Overdue"
                openPopup={openQuick_Payment_StatusModal}
                setOpenPopup={setOpenQuick_Payment_StatusModal}
                size="lg"
                centered
                fade={false}
            >
                <QuickbookPaymentStatus
                    loginUserDetails={loginUserDetails}
                    setOpenQuick_Payment_StatusModal={
                        setOpenQuick_Payment_StatusModal
                    }
                />
            </ModalCustom> */}

            <>
                <Modal
                    isOpen={openAPIAccessModal}
                    toggle={() => {
                        setOpenAPIAccessModal(false);
                    }}
                    onClosed={() => {
                        setOpenAPIAccessModal(false);
                    }}
                    size="xl"
                    scrollable={true}
                    centered
                >
                    <ModalHeader
                        toggle={() => {
                            setOpenAPIAccessModal(!openAPIAccessModal);
                        }}
                    >
                        Manage API Access
                    </ModalHeader>
                    <ModalBody className="fs--1 font-weight-normal p-0">
                        <Form onSubmit={handleSubmit(handleAddingOfAPIAccess)}>
                            <Row className="p-0">
                                <Col>
                                    <Row>
                                        <Col className="col-sm-6 col-12">
                                            <FormGroup
                                                as={Col}
                                                className="mb-3 align-items-center pl-3 pt-3"
                                                controlId="formHorizontalPassword"
                                            >
                                                <FormLabel
                                                    className="d-sm-flex pl-0"
                                                    style={{ fontSize: "13px" }}
                                                    column
                                                >
                                                    Domain(s)
                                                </FormLabel>
                                                <SikkaSelect
                                                    placeholder="Select a practice"
                                                    // styles={selectStyles}
                                                    classNamePrefix="react-select"
                                                    options={domains.map(
                                                        (option, index) => {
                                                            return {
                                                                value: index,
                                                                label: option,
                                                            };
                                                        }
                                                    )}
                                                    value={{
                                                        value: domainIdx,
                                                        label:
                                                            domains[domainIdx],
                                                    }}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setDomainIdx(
                                                            selectedOption.value
                                                        );
                                                        apiAccessData.app_domain =
                                                            domains[
                                                                selectedOption.value
                                                            ];
                                                        setApiAccessData([
                                                            ...apiAccessData,
                                                        ]);
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup
                                                className="mb-3 pl-sm-3 pl-0"
                                                controlId="formHorizontalPassword"
                                                style={{ paddingTop: "18px" }}
                                            >
                                                <Col sm={12}>
                                                    <SikkaInput
                                                        label="API Limit Note*"
                                                        name="apiLimitNote"
                                                        id="apiLimitNote"
                                                        defaultValue={
                                                            apiLimitNote
                                                        }
                                                        placeholder="Enter API Limit Note"
                                                        size="lg"
                                                        innerRef={register({
                                                            required:
                                                                "API Limit Note is required",
                                                        })}
                                                        errors={errors}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Col className="p-0">
                                        <Card>
                                            <TabContainer
                                                id="audience-tab"
                                                defaultActiveKey="GET"
                                            >
                                                <CardHeader
                                                    as={Flex}
                                                    justifyContent="between"
                                                    alignItems="center"
                                                    className="ps-0 py-0 border-bottom"
                                                >
                                                    <Nav
                                                        as="ul"
                                                        className="nav-tabs border-0 chart-tab tab-active-caret sm"
                                                    >
                                                        {navItems.map(
                                                            (item) => (
                                                                <NavItemComponent
                                                                    item={item}
                                                                    key={item}
                                                                />
                                                            )
                                                        )}
                                                    </Nav>
                                                </CardHeader>

                                                <CardBody>
                                                    <Row className="g-1">
                                                        <Col>
                                                            <TabContent>
                                                                {/* 0-------------------- */}
                                                                <TabPane
                                                                    unmountOnExit
                                                                    eventKey="GET"
                                                                >
                                                                    <APIAccessListItem
                                                                        method="GET"
                                                                        data={
                                                                            apiAccessNameData?.[
                                                                                "get"
                                                                            ]
                                                                        }
                                                                        handleChange={
                                                                            handleChange
                                                                        }
                                                                        selectedApiNames={
                                                                            selectedApiNames
                                                                        }
                                                                        disableApiAccessSelection={
                                                                            disableApiAccessSelection
                                                                        }
                                                                    />
                                                                </TabPane>
                                                                {/* 1-------------------- */}
                                                                <TabPane
                                                                    unmountOnExit
                                                                    eventKey="POST"
                                                                >
                                                                    <APIAccessListItem
                                                                        method="POST"
                                                                        data={
                                                                            apiAccessNameData?.[
                                                                                "post"
                                                                            ]
                                                                        }
                                                                        handleChange={
                                                                            handleChange
                                                                        }
                                                                        selectedApiNames={
                                                                            selectedApiNames
                                                                        }
                                                                        disableApiAccessSelection={
                                                                            disableApiAccessSelection
                                                                        }
                                                                    />
                                                                </TabPane>
                                                                {/* 2-------------------- */}
                                                                <TabPane
                                                                    unmountOnExit
                                                                    eventKey="PUT"
                                                                >
                                                                    <APIAccessListItem
                                                                        method="PUT"
                                                                        data={
                                                                            apiAccessNameData?.[
                                                                                "put"
                                                                            ]
                                                                        }
                                                                        handleChange={
                                                                            handleChange
                                                                        }
                                                                        selectedApiNames={
                                                                            selectedApiNames
                                                                        }
                                                                        disableApiAccessSelection={
                                                                            disableApiAccessSelection
                                                                        }
                                                                    />
                                                                </TabPane>
                                                                {/* 3-------------------- */}
                                                                <TabPane
                                                                    unmountOnExit
                                                                    eventKey="DELETE"
                                                                >
                                                                    <APIAccessListItem
                                                                        method="DELETE"
                                                                        data={
                                                                            apiAccessNameData?.[
                                                                                "delete"
                                                                            ]
                                                                        }
                                                                        handleChange={
                                                                            handleChange
                                                                        }
                                                                        selectedApiNames={
                                                                            selectedApiNames
                                                                        }
                                                                        disableApiAccessSelection={
                                                                            disableApiAccessSelection
                                                                        }
                                                                    />
                                                                </TabPane>
                                                                {/* 4-------------------- */}
                                                                <TabPane
                                                                    unmountOnExit
                                                                    eventKey="PATCH"
                                                                >
                                                                    <APIAccessListItem
                                                                        method="PATCH"
                                                                        data={
                                                                            apiAccessNameData?.[
                                                                                "patch"
                                                                            ]
                                                                        }
                                                                        handleChange={
                                                                            handleChange
                                                                        }
                                                                        selectedApiNames={
                                                                            selectedApiNames
                                                                        }
                                                                        disableApiAccessSelection={
                                                                            disableApiAccessSelection
                                                                        }
                                                                    />
                                                                </TabPane>
                                                            </TabContent>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3 d-flex justify-content-between align-items-center">
                                                        <FormGroup>
                                                            <Col className="d-flex justify-content-end pt-3">
                                                                <Button
                                                                    className="mr-2"
                                                                    type="submit"
                                                                    variant="success"
                                                                    size="sm"
                                                                >
                                                                    Save
                                                                </Button>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        setOpenAPIAccessModal(
                                                                            false
                                                                        );
                                                                        setShowApiAccessButtonClickedCancel(
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Col>
                                                        </FormGroup>
                                                    </Row>
                                                </CardBody>
                                            </TabContainer>
                                        </Card>
                                    </Col>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                </Modal>
            </>
            <ConfirmationModal
                toggle={toggle}
                IsConfirmationModal={IsConfirmationModal}
                handleRefreshSecretKey={handleRefreshSecretKey}
            />
        </>
    );
};
export default ApplicationDetails;

const ConfirmationModal = ({
    toggle,
    IsConfirmationModal,
    handleRefreshSecretKey,
}) => {
    return (
        <>
            <Modal
                centered={true}
                isOpen={IsConfirmationModal}
                fade={false}
                toggle={toggle}
            >
                <ModalHeader>
                    Are you sure you want to Reset Secret key?
                </ModalHeader>
                <ModalBody>
                    <p>
                        Once you reset secret key,all existing request keys will
                        be expired & need to generate new request key.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="mr-2"
                        onClick={handleRefreshSecretKey}
                        variant="danger"
                        size="sm"
                    >
                        Yes
                    </Button>
                    <Button variant="secondary" size="sm" onClick={toggle}>
                        No
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
